// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort-toggle[data-v-8a847ae0]{cursor:pointer;display:inline-block;height:1rem;position:relative}.sort-arrow[data-v-8a847ae0]{position:absolute;top:.25rem}.large-icon[data-v-8a847ae0]{bottom:.25rem}.large-icon .fa-sort-down[data-v-8a847ae0],.large-icon .fa-sort-up[data-v-8a847ae0]{font-size:1.25em;line-height:1.25em;bottom:.25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
